// The post-header strip (mockup a-discussion-1.png, variant 1 by default): the level roundel on the avatar's corner,
// under the name a slim EXP bar with %, the game chip "Lv 87 · Warrior · [flag] · Guild", up to 3 medals + "+N".
// Variant 2 (forum setting aethernal-forum.gamify_badge = shield): the shield at the strip's start instead of the
// roundel on the avatar (a-discussion-2.png). Phones (e-discussion-phone.png): the emblem leads the strip, the strip
// wraps into three rows (emblem + EXP, chip, medals). Everything comes with the post's user (field aetGamify):
// no extra request, no extra query.
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Comment from 'flarum/forum/components/Comment';
import { gamifyOf, badgeStyle, EmblemWithTip, ExpBar, Chip, Medals } from './ui';
export function Strip(g) {
  const sep = m("span", {
    className: "aet-strip__sep",
    "aria-hidden": "true"
  });
  const shield = badgeStyle() === 'shield';
  return m("div", {
    className: `aet-strip ${shield ? 'aet-strip--shield' : 'aet-strip--roundel'}`
  }, m("span", {
    className: "aet-strip__lead"
  }, EmblemWithTip(g, 'md', shield ? '' : 'aet-strip__phone-lv'), ExpBar(g.pct, '', true)), g.chip ? [sep, m("span", {
    className: "aet-strip__chip"
  }, Chip(g.chip))] : null, g.medals && g.medals.length ? [sep, m("span", {
    className: "aet-strip__medals"
  }, Medals(g.medals, 3))] : null);
}
export default function addStrip() {
  // the roundel on the avatar (variant 1; hidden on phones, where the strip shows it)
  extend(CommentPost.prototype, 'sideItems', function (items) {
    const user = this.attrs.post.user();
    const g = gamifyOf(user);
    if (!g || badgeStyle() !== 'roundel' || this.attrs.post.isHidden()) return;
    items.add('aetLevel', m("span", {
      className: "aet-post-lv"
    }, EmblemWithTip(g, 'md')), 90);
  });

  // the strip between the post header and the body
  extend(Comment.prototype, 'view', function (vdom) {
    const g = gamifyOf(this.attrs.user);
    if (!g || this.attrs.isHidden || !Array.isArray(vdom)) return;
    vdom.splice(1, 0, Strip(g));
  });
}
flarum.reg.add('aethernal-forum', 'forum/gamify/strip', addStrip);